import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useApi } from "../utils/api";
import { ENDPOINTS } from "../config/endpoints";
import { Box } from "@mui/material";
import EmployeeHeader from "../components/employee/EmployeeHeader";
import EmployeeTabs from "../components/employee/EmployeeTabs";
import EmployeeInfoTab from "../components/employee/EmployeeInfoTab";
import EmployeeFilesTab from "../components/employee/EmployeeFilesTab";
import EmployeeSalaryTab from "../components/employee/EmployeeSalaryTab";


const EmployeeDetail = () => {
  const { id } = useParams();
  const http = useApi();

  const [activeTab, setActiveTab] = useState("Çalışan Bilgileri");
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const tabs = ["Çalışan Bilgileri", "Dosyalar", "Ücret"];

  useEffect(() => {
    if (!id) return;

    const fetchEmployee = async () => {
      setLoading(true);
      setError("");
      try {
        const data = await http.get(ENDPOINTS.PERSONEL.DETAIL(id));
        setEmployee(data);
      } catch (err) {
        setError(err.message || "Personel bilgisi alınamadı.");
      } finally {
        setLoading(false);
      }
    };

    fetchEmployee();
  }, [id, http]);

  const handleToggleActive = async () => {
  try {
    const updated = await http.put(ENDPOINTS.PERSONEL.TOGGLE_AKTIF(id));
    setEmployee(updated);
  } catch (err) {
    setError(err.message || "Durum güncellenemedi.");
  }
};

  const fullName = employee
    ? `${employee.ad || ""} ${employee.soyad || ""}`.trim()
    : "Yükleniyor...";
  const initials = employee
    ? `${(employee.ad || "")[0] || ""}${(employee.soyad || "")[0] || ""}`.toUpperCase()
    : "PR";

  return (
    <Box sx={{ display: "flex", height: "100vh", bgcolor: "#f9fafb" }}>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <EmployeeHeader
          fullName={fullName}
          initials={initials}
          employee={employee}
          onToggleActive={handleToggleActive}
        />

        <EmployeeTabs
          tabs={tabs}
          activeTab={activeTab}
          onChange={setActiveTab}
        />

        <Box
          sx={{
            bgcolor: "white",
            p: 3,
            borderRadius: 2,
            boxShadow: 1,
            minHeight: 400,
          }}
        >
          {activeTab === "Çalışan Bilgileri" && (
            <EmployeeInfoTab
              employee={employee}
              loading={loading}
              error={error}
            />
          )}

          {activeTab === "Dosyalar" && employee && (
            <EmployeeFilesTab personelId={employee.id} employee={employee} />
          )}

          {activeTab === "Ücret" && employee && (
            <EmployeeSalaryTab personel={employee} />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default EmployeeDetail;